import type { Langue } from '@artosera/shared';
import { useTranslation } from 'react-i18next';

/** La langue de l'interface de la régie, réduite aux deux langues du produit. */
export function useLangue(): Langue {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'fr';
}
